<template lang="pug">
  // v-speed-dial(
    v-model="model"
    bottom
    :style="style"
    fixed
    right
    style="z-index: 205")
    template(#activator)
  v-slide-x-reverse-transition
    self-activator(
      v-if="bottomShortcut"
      :key="bottomShortcut.id"
      :bottomShortcut="bottomShortcut")
    //
      v-btn(
        fab
        small)
        v-icon {{ $get(bottomShortcut, `icon`) }}
      v-btn(
        fab
        small)
        v-icon {{ $get(bottomShortcut, `icon`) }}
      v-btn(
        fab
        small)
        v-icon {{ $get(bottomShortcut, `icon`) }}
</template>

<script>
import { state } from '..'
import { toRefs, computed, watch, ref } from '@vue/composition-api'

import { VFadeTransition, VBtn, VIcon } from 'vuetify/lib'
import SelfActivator from './activator/'

export default {
  components: {
    VFadeTransition, VBtn, VIcon,
    SelfActivator
  },

  setup () {
    const model = ref(``)

    return {
      ...toRefs(state),
      model
    }
  }
}
</script>
